<div [dir]="language == 'ar' ? 'rtl' : 'ltr'" class="article-cont my-5">
    <h2 class="text-center mb-3 mb-md-4">{{ 'header_articles' | translate }}</h2>

    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!isLoading && articles.length === 0" class="text-center">
        <p>{{ 'no_articles_found' | translate }}</p>
    </div>

    <div class="row g-4 justify-content-end">
        <div class="col-12 col-md-4 px-md-3" *ngFor="let article of articles">
            <div class="article-card h-100 d-flex flex-column">
                <div class="article-card-img-wrapper">
                    <img *ngIf="article.imageUrl" class="article-card-img" [src]="article.imageUrl"
                        [alt]="article.title" />
                    <div *ngIf="!article.imageUrl" class="article-card-img-placeholder">
                        {{ 'no_image' | translate }}
                    </div>
                </div>
                <div class="article-card-body d-flex flex-column flex-grow-1">
                    <h2 class="article-title mb-2">{{ article.title }}</h2>
                    <p class="article-summary mb-3">{{ article.description }}</p>
                    <div class="mt-auto">
                        <a class="btn w-100" [routerLink]="getArticleUrl(article)">
                            {{ 'اقرأ المقال' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>